import FormField from "./FormField";
import { Dispatch, SetStateAction } from "react";
import { cloneDeep } from "lodash";

interface Props {
  formData: Response[];
  setFormData: Dispatch<SetStateAction<Response[]>>;
}

interface AnswerOption {
  uuid: string;
  question: string | null;
  answer: string;
}

interface Question {
  id: number;
  uuid: string;
  type: string;
  question: string;
  sequenceId: number;
  answerType: string;
  answersOptions: AnswerOption[];
}

interface Patient {
  [key: string]: string;
}
export interface DropDownOptions {
  uuid: string;
  question: string | null;
  answer: string;
}
export interface Response {
  uuid: string;
  answer: string | null;
  question: Question;
  patient: Patient;
  active: boolean;
  archive: boolean;
  answersOptions: DropDownOptions[]; // You can replace `any` with a more specific type if available
  notes: string | null;
}

const DynamicForm = ({ formData, setFormData }: Props) => {
  // const [notes, setNotes] = useState<Record<number, string | undefined>>({});

  // const handleInputChange = (id: number, value: string | null) => {
  // setFormData((prev) => ({ ...prev, [id]: value }));
  // };

  const handleNoteChange = (idx: number, value: string | null) => {
    const copyedData = cloneDeep(formData);
    copyedData[idx].answer = value;
    setFormData(copyedData);
  };

  // console.log("formValues", formValues);
  // console.log("notes", notes);

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        columnGap: "24px",
        rowGap: "12px",
        padding: "12px",
      }}
    >
      {formData?.map((q, idx) => (
        <div key={q.uuid} style={{ flex: "0 0 calc(30.333% - 16px)" }}>
          <FormField
            idx={idx}
            questionType={q.question.answerType}
            question={q.question.question}
            value={q.answer}
            onChange={(value) => handleNoteChange(idx, value)}
            dropDownOptions={q.question.answersOptions}
          />
        </div>
      ))}
    </div>
  );
};

export default DynamicForm;
